import { checkPhone, userLogin } from '@/api/api_user'
import { Message } from 'element-ui'
const state = {
    token: null,
    userInfo: {}
}
const mutations = {
    SET_TOKEN: (state, value) => {
        state.token = value
    },

    SET_USERINFO: (state, userInfo) => {
        state.userInfo = userInfo
    }
}
const actions = {
    userLogin({ commit }, userInfo) {
        const {
            account,
            password
        } = userInfo
        return new Promise((resolve, reject) => {
            userLogin({ PHONENUM: account, PWD: password }).then(response => {
                const token = response.data;
                if (response.type === 'error') {//登录失败,用户名或密码错
                    Message.error(response.message); //提示出错信息
                } else {//成功
                    sessionStorage.setItem('userInfo', JSON.stringify(response));
                    //console.log(JSON.stringify(response))
                    commit('SET_TOKEN', token);
                    //Message.success('登录成功!');//不在这里显示,后面还要校验到期时间
                }
                resolve();
            }).catch(error => {
                reject(error);
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}